import React, { useCallback, useId } from "react";
import { useNavigate } from "react-router-dom";
import { CorePlansLists, FeaturedBenefits } from "../../../../constants/benefits.constants";
import CoreMainImage from "../../../../assets/CorePlanImages/CoreMainImage.avif";
import "./coreplans.scss";

const CorePlans: React.FC = (): JSX.Element => {
	const navigate = useNavigate();
	const mapId = useId();

	const handleExploreClick = () => {
		const contentToScrollTo = document.getElementById("AllPlans");

		if (contentToScrollTo) {
			contentToScrollTo.scrollIntoView({ behavior: "smooth" });
		}
	};

	const handleRedirectToPlanPage = useCallback(
		(planType: string, planRoutePage: string) => {
			const redirectionRoute = `/plans/${planType}/${planRoutePage}`;
			navigate(redirectionRoute);
		},
		[navigate]
	);

	return (
		<div className="core-plans-main-container">
			<div className="coreGrid">
				<div className="firstCoreGrid">
					<h1 className="coreText">Core</h1>
					<h2 className="corePlansText">
						Plans<span id="corespin"> </span>
					</h2>

					<p className="coreDescText">
						Embark on a Journey of Well-being: Delve into the Spectrum of Employee Benefits Tailored
						Exclusively for You. From Health and Financial Security to Professional Growth and Work-Life
						Harmony, Our Comprehensive Benefits Package Reflects Our Commitment to Your Holistic Success.
						Explore the Myriad Opportunities and Perks that Await You, and Let Us Enhance Your Work
						Experience Beyond the Ordinary. Because Your Prosperity and Contentment Matter – Your Benefits,
						Your Future.
					</p>
				</div>

				<div className="secondCoreGrid">
					<img className="insuranceImg" src={CoreMainImage} alt="Core main insurance image" />
					<button className="explore-button" onClick={handleExploreClick}>
						Explore
					</button>
				</div>
			</div>

			<h3 className="main-title">Group Plans</h3>

			<div id="AllPlans">
				<div className="benefit-article-main-container" id="benefit-article-main-container">
					<div className="grid-container">
						{CorePlansLists.map((data: FeaturedBenefits) => {
							const { planType, planRedirectionRoute } = data;
							return (
								<div
									className="grid-item-container"
									onClick={() =>
										handleRedirectToPlanPage(planType.toLowerCase(), planRedirectionRoute)
									}
									key={mapId}
								>
									<div
										className="sponsored-ribbon-wrapper"
										style={
											data.planType === "CORE"
												? {
														background: "linear-gradient(to right, #f40752, #f9ab8f)"
													}
												: {
														background: "linear-gradient(to right, #a223d1, #4631ce)"
													}
										}
									>
										<div className="glows">&nbsp;</div>
										<span className="ribbon-text">{data.planType === "CORE" && "Core Plan"}</span>
										<div className="ribbon-text-support"></div>
									</div>
									<div className="grid-item">
										<img src={data.cardImage} alt="" />
										<div className="gradient-ribbon" />
										<span className="card-title">{data.cardTitle}</span>
										<span className="card-description">{data.cardDescription}</span>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CorePlans;
